@import (reference) '../../../../../constants/spacing.module.less';

.items-section-content {
  padding: @space-0;
}
